import React from "react";
import {LucideIcon} from "lucide-react";
import {cn} from "./cn";

export interface SectionProps {
    icon?: LucideIcon;
    title: string;
    description?: string;
    action?: React.ReactNode;
    children: React.ReactNode;
    className?: string;
}

export const Section: React.FC<SectionProps> = ({icon: Icon, title, description, action, children, className}) => (
    <div className={cn("space-y-3", className)}>
        <div className="flex items-center justify-between gap-3">
            <div className="flex items-center gap-2">
                {Icon && <Icon size={15} strokeWidth={2.25} className="text-ink-muted shrink-0"/>}
                <h3 className="text-sm font-semibold text-ink">{title}</h3>
            </div>
            {action}
        </div>
        {description && <p className="text-xs text-ink-muted -mt-2">{description}</p>}
        {children}
    </div>
);
